import RedemptionMainError from './redemption-main-error.component';

export default RedemptionMainError;
